import {
  ImmomioButtonComponent,
  ImmomioIconButtonComponent
} from '@immomio/ui/button';
import {
  Component,
  computed,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';

import {
  ITPSettings,
  PropertyMatchBean,
  RentDepositInfo
} from '@ui/shared/model';

import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { Go, ModalContentComponent, ModalV2Component } from '@ui/legacy-lib';
import { showAssistant } from '@ui/tenant-pool/shared/config/util';
import { MainPageNavigation } from '../../config/navigation.config';

@Component({
  selector: 'app-tenant-experience-modal',
  templateUrl: './tenant-experience-modal.component.html',
  styleUrls: ['./tenant-experience-modal.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ImmomioIconButtonComponent,
    SvgIconComponent,
    TranslatePipe,
    ModalV2Component,
    ModalContentComponent
  ]
})
export class TenantExperienceModalComponent {
  readonly foundApplication = input<PropertyMatchBean>(undefined);
  readonly rentDepositInfo = input<RentDepositInfo>(undefined);
  readonly itpSettings = input<ITPSettings>(undefined);
  private store = inject(Store);
  private ngbActiveModal = inject(NgbActiveModal);

  public readonly showAssistantRedirect = computed(() =>
    showAssistant(this.itpSettings())
  );

  public dismiss() {
    this.ngbActiveModal.dismiss();
  }

  public close() {
    this.ngbActiveModal.close();
  }

  public goToRentDeposit() {
    this.store.dispatch(
      new Go({
        path: ['rent-deposit', this.foundApplication().id]
      })
    );
    this.close();
  }

  public goToNewHome() {
    this.store.dispatch(
      new Go({
        path: [MainPageNavigation.NEW_HOME]
      })
    );
    this.close();
  }

  public goToMovingAssistant() {
    this.store.dispatch(
      new Go({
        path: [MainPageNavigation.SERVICE_CENTER]
      })
    );
    this.close();
  }
}
